import styled from 'styled-components';

export const MainContainerBox = styled.div`
  padding: 5px;
`;

export const CustomFlexWrap = styled.div`
  display: flex;
`;

export const BarMainGraph = styled.div`
  display: flex;
`;

export const YAxisContainer = styled.div`
  position: relative;
  left: 0px;
  width: 100%;
  flex: 0;
  display: flex;
  transform: rotateZ(180deg);
  text-align: center;
  top: 0;
`;

export const YAxisContainerTitle = styled.div`
  width: 100%;
  font-size: 14px;
  writing-mode: vertical-rl;
  color: #748aa1;
  @media print {
    margin-right: 70px;
  }
`;

export const MainBarContainer = styled.div`
  flex: 1;
  margin-left: 0px;
`;

export const BarChartWrapper = styled.div`
  display: table;
  position: relative;
  margin: 20px 0;
  height: 320px;
  height: 260px;
`;

export const BarChartTimeCol = styled.div`
  position: absolute;
  top: 20%;
  width: 2%;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  padding-top: 10px;
`;

export const BarChartTimeText = styled.div`
  position: absolute;
  top: -9px;
  z-index: 1;
  padding-right: 4px;
  font-size: 13px;
  display: block;
  text-align: right;
  color: #748aa1;
  width: 60px;
`;

export const BarChartTime = styled.div`
  vertical-align: middle;
  position: relative;
  height: 50px;
  &::after {
    content: '';
    position: absolute;
    width: 10000%;
    left: 60px;
    top: 0;
    border-bottom: 2px dashed rgba(102, 102, 102, 0.3);
  }
  ,
  &:first-child ${BarChartTimeText} {
    top: -5px !important;
  }
  ,
  &:last-child ${BarChartTimeText} {
    top: -15px;
  }
  ,
  &:last-child::after {
    border-bottom: none;
  }
`;

export const BarChartContainer = styled.div`
  display: table-cell;
  width: calc(100% - 45px);
  height: 100%;
  padding-left: 15px;
  float: right;
`;

export const BarChart = styled.div`
  display: table;
  table-layout: fixed;
  height: 100%;
  width: 100%;
  border-left: 1px solid #666666;
  border-bottom: 1px solid #666666;
`;

export const BarChartFooter = styled.div`
  margin: 0 auto;
  left: 4px;
  border-top-left-radius: unset !important;
  border-top-right-radius: unset !important;
  width: calc(100% - 7px);
  overflow-wrap: break-word;

  position: absolute;
  text-align: center;
  height: 10%;
  padding-top: 5px;
  font-size: 13px;
  color: #748aa1;
  font-weight: normal;

  ${(props) =>
    props.isSelectable &&
    `
    border: 1px solid #D0D7E3;
    border-radius: 0px 0px 4px 4px;`},

  ${(props) =>
    props.isSelectable &&
    props.isActive &&
    `
    border: 1px solid #21B4BD;
    background-color: #21B4BD;
    color: #FFFFFF;
    `}
`;

export const BarSingleBox = styled.div`
  position: relative;
  border-radius: 4px;
  height: 100% !important;
  overflow: hidden;
  margin: 0 4px;
  ${(props) =>
    props.isSelectable &&
    `
    cursor: pointer;
    border: 1px solid #D0D7E3;`}
`;

export const BarChartCol = styled.div`
  position: relative;
  vertical-align: bottom;
  display: table-cell;
  height: 100%;

  ${(props) =>
    props.isSelectable &&
    `
    &:hover {
      ${BarSingleBox} {
        border:  1px solid #21B4BD;
        border-radius: 4px;
        border-bottom-left-radius: unset;
        border-bottom-right-radius: unset;
      }
      ${BarChartFooter} {
        border: 1px solid #21B4BD;
      }
    }`},

  ${(props) =>
    props.isSelectable &&
    props.isActive &&
    `
    ${BarSingleBox} {
      border:  1px solid #21B4BD;
      border-radius: 4px;
      border-bottom-left-radius: unset;
      border-bottom-right-radius: unset;
    }
  `}
`;

export const BarSingleBoxUL = styled.ul`
  padding: 0;
  display: flex;
  align-items: flex-end;
  height: 100%;
  justify-content: center;
`;

export const BarSingleBoxLI = styled.li`
  list-style: none;
  height: 100%;
  display: flex;
  align-items: flex-end;
  position: relative;
`;

export const SingleBar = styled.div`
  width: 9px;
  background: ${(props) => (props.color ? props.color : '#000')};
  height: ${(props) =>
    props.height ? `${(props.height / props.highestTick) * 80}%` : '30%'};
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  margin: 0 12px;
  position: relative;
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
`;

export const SingleBarCount = styled.span`
  font-weight: 700;
  margin-bottom: 40px;
  display: block;
  position: absolute;
  top: -15px;
  // left: 0;
  font-size: 13px;
  color: #31394d;
  left: 50%;
  transform: translateX(-50%);
`;

export const PaginationContainer = styled.div`
  width: 100%;
  margin-top: 20px;
  height: 20%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;

export const PaginationButton = styled.button`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #31394d;
  background: #ffffff;
  border: 1px solid #d0d7e3;
  box-sizing: border-box;
  border-radius: 4px;
  height: 28px;
  width: 28.88px;
  margin: 0px 6px;
  text-align: center;
  border: ${(props) =>
    props.isActive ? '1px solid #21B4BD;' : '1px solid #D0D7E3;'};
  color: ${(props) => (props.isActive ? '#21B4BD' : '#31394D;')};
  &:hover {
    color: #21b4bd;
    border: 1px solid #21b4bd;
  }
`;

export const PaginationLbl = styled.label`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-align: right;
  color: #b8bec5;
  margin: 5px 6px;
  @media print {
    padding-top: 30px;
  }
`;

export const PaginationNextArrow = styled.button`
  background: #ffffff;
  border: 1px solid #d0d7e3;
  box-sizing: border-box;
  border-radius: 4px;
  height: 28px;
  width: 28.88px;
  margin: 0px 6px;
  text-align: center;
  opacity: ${(props) => (props.isDisabled ? '0.6' : '1')};
  &:hover {
    border: ${(props) =>
      props.isDisabled ? 'border: 1px solid #D0D7E3;' : '1px solid #21B4BD;'};
  }
`;

export const PaginationPrevArrow = styled.button`
  background: #ffffff;
  border: 1px solid #d0d7e3;
  box-sizing: border-box;
  border-radius: 4px;
  height: 28px;
  width: 28.88px;
  margin: 0px 6px;
  text-align: center;
  opacity: ${(props) => (props.isDisabled ? '0.6' : '1')};
  &:hover {
    border: ${(props) =>
      props.isDisabled ? 'border: 1px solid #D0D7E3;' : '1px solid #21B4BD;'};
  }
`;

export const BarStatusBox = styled.div`
  position: relative;
  bottom: -15px;
  margin-left: 40px;
  flex: 0.12;
  min-width: 100px;
`;

export const BarStatusTitle = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #31394d;
`;

export const BarStatusUL = styled.ul`
  padding: 0;
`;

export const BarStatusLI = styled.li`
  list-style: none;
  font-size: 14px;
  padding: 7px 0;
  position: relative;
  color: #31394d;
  &:before {
    content: '';
    position: absolute;
    top: 15px;
    left: -25px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${(props) => (props.color ? props.color : '#b7c2d2')};
  }
`;

export const BarStatusTotalCount = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
`;

export const BarStatusTotalCountValue = styled.span`
  background: #f7f7f8;
  padding: 10px;
  border-radius: 8px;
  font-size: 13px;
  color: #31394d;
`;
